export const Drawers = {
    AddTaskNote: 'add-task-note',
    CareConfirmation: 'care-confirmation',
    CompleteInsight: 'complete-insight',
    Confirmation: 'confirmation',
    DeviceReset: 'device-reset',
    DetectReviewOutcome: 'detect-review-outcome',
    DoorScheduleDrawer: 'door-schedule-drawer',
    ExploreInsights: 'explore-insights',
    PhoneSubscription: 'phone-subscription',
    ReceiveHighFive: 'receive-high-five',
    ResidentDetails: 'resident-details',
    ResidentPendants: 'resident-pendants',
    ResolveTask: 'resolve-task',
    SelectCareTasksAndOutcomes: 'select-care-tasks-and-outcomes',
    SelectCareZone: 'select-care-zone',
    ComputerDevicePhoneVerification: 'computer-device-phone-verification',
    SelectDevice: 'select-device',
    SelectEmergencyReason: 'select-emergency-reason',
    SelectEnterprise: 'select-enterprise',
    SelectMultiOutcomeResolution: 'select-multi-outcome-resolution',
    SelectProactiveResolution: 'select-proactive-resolution',
    SelectSectionGgResolution: 'select-section-gg-resolution',
    SelectShift: 'select-shift',
    ShiftDrift: 'shift-drift',
    AddObservations: 'add-observations',
    SelectOptions: 'select-options',
    SelectPerson: 'select-person',
    SelectResidentsWithButtons: 'select-residents-with-buttons',
    SelectResolutionType: 'select-resolution-type',
    SelectRoomCheckin: 'select-room-checkin',
    SelectDoor: 'select-door',
    SelectUnit: 'select-unit',
    SelectWard: 'select-ward',
    SelectWasFall: 'select-was-fall',
    SendHighFive: 'send-high-five',
    StaffMemberActionsDrawer: 'staff-member-actions-drawer',
    UnitCheckIn: 'unit-check-in',
    UnitDetail: 'unit-detail',
    VerifyPhoneNumber: 'verify-phone-number',
} as const;

export type DrawerType = (typeof Drawers)[keyof typeof Drawers];
